export default __webpack_public_path__ + "static/media/filter.2c1ddabe.svg";